module.exports = __webpack_public_path__ + "static/media/security.3efb6abb.jpg";